/* Copyright (c) 2017 Backpack Health LLC */
import * as _ from 'lodash';

import MedicalJewelryService from '../../../apiServices/MedicalJewelryService';
import { IJewelryProvider } from '../../../models/JewelryProvider';

const types = {
  REQUEST: 'app/medicalJewelry/REQUEST',
  RECEIVE: 'app/medicalJewelry/RECEIVE',
};

const initialState = {
  collection: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.RECEIVE:
      return _.assign({}, state, {
        collection: _.assign({}, state.collection, { [action.profileId]: action.payload }),
      });
    default:
      return state;
  }
}

export const selectors = {
  getAll(state, profileId): IJewelryProvider[] { return _.get(state, `medicalJewelry.collection.${profileId}`, null) || []; },
  getSupportedCountry(state, profileId): IJewelryProvider[] { return (_.get(state, `medicalJewelry.collection.${profileId}`, null) || []).filter(m => m.supported_country); },
  getUnsupportedCountry(state, profileId): IJewelryProvider[] { return (_.get(state, `medicalJewelry.collection.${profileId}`, null) || []).filter(m => !m.supported_country); },
  isProviderDataLoaded(state, profileId) { return _.get(state, `medicalJewelry.collection.${profileId}`, null) !== null; },
};

function requestMedicalJewelryProviders(profileId) {
  return (dispatch) => {
    MedicalJewelryService.getAllProviders(profileId, (apiError, payload) => {
      dispatch({
        type: types.RECEIVE,
        profileId,
        payload,
      });
    });
  };
}

export const actions = {
  request: requestMedicalJewelryProviders,
};
